// extracted by mini-css-extract-plugin
export default {"container":"PhotoList_container__rxc+S","cardContainer":"PhotoList_cardContainer__4Cyty"};